import { ResidentNeed } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'

import { useQuery } from 'react-query'
import { getResidentBaseFunction } from 'selectors/NeedsAndSkills'

type UseResidentNeedsProps = {
  id: string
}

type UseResidentNeeds = {
  needs: Array<ResidentNeed & { needName: string }>
  isLoading: boolean
}

export const SKILL_NEED_TEMPLATES_CATEGORIES_URL =
  'list/skill-need-templates/categories?needs=1'

const getResidentNeedsUrl = (id: string) => `/api/list/residents/${id}/needs`

const useResidentNeeds = ({ id }: UseResidentNeedsProps): UseResidentNeeds => {
  const { isLoading: isLoadingCategoriesNeeds, data: categoriesNeedsData } =
    useQuery(
      ['skill-need-templates-categories-need'],
      () =>
        getJSON({
          url: SKILL_NEED_TEMPLATES_CATEGORIES_URL,
        }),
      { enabled: !!id }
    )

  const { data: residetNeedsData, isLoading: isLoadingNeedsData } = useQuery(
    ['resident-needs', id],
    () =>
      getJSON({
        url: getResidentNeedsUrl(id as string),
      }),
    { enabled: !!id }
  )

  const needs = getResidentBaseFunction(
    id as string,
    categoriesNeedsData?.result,
    residetNeedsData?.result
  ) as Array<ResidentNeed & { needName: string }>

  return { needs, isLoading: isLoadingCategoriesNeeds || isLoadingNeedsData }
}

export default useResidentNeeds
